'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosSpeedometerOutline = function IoIosSpeedometerOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 5c9.7 0 17.5 7.8 17.5 17.5 0 4.5-1.6 8.4-4.4 11.6-0.3 0.3-0.5 0.6-0.8 0.9l-0.8-0.8-0.1-0.1c-1.5-1.4-3.2-2.6-5.1-3.4-2-0.9-4.1-1.2-6.3-1.2s-4.3 0.3-6.3 1.2c-1.9 0.8-3.6 2-5.1 3.4l-0.1 0.1-0.8 0.8c-0.3-0.3-0.5-0.6-0.8-0.9-2.8-3.2-4.4-7.1-4.4-11.6 0-9.7 7.8-17.5 17.5-17.5z m15 23.8c0.8-1.8 1.2-3.7 1.3-5.7h-2.5v-1.2h2.5c-0.1-2-0.5-3.9-1.3-5.7-0.7-1.7-1.8-3.3-3-4.7l-2.2 2.1-0.8-0.9h-0.1l2.1-2.1c-1.4-1.3-3-2.4-4.7-3.1-1.8-0.8-3.7-1.2-5.8-1.2v2.9h-1.2v-2.9c-2 0-3.8 0.4-5.6 1.2-1.7 0.8-3.4 1.8-4.8 3.1l2.1 2.1-0.8 0.9-2.2-2.1c-1.2 1.4-2.3 3-3 4.7-0.8 1.8-1.2 3.8-1.3 5.8h2.5v1.2h-2.5c0.1 2 0.5 3.8 1.3 5.6 0.7 1.6 1.6 3.1 2.7 4.4 3.2-3.1 7.5-5 12.3-5s9.1 1.9 12.3 5c1.1-1.3 2-2.8 2.7-4.4z m-6.2-15.1l0.1 0-5.9 6.6c0.5 0.6 0.8 1.4 0.8 2.2 0 2-1.8 3.8-3.8 3.8-0.8 0-1.5-0.4-2.1-0.8l-1 1-0.9-0.9 1-0.9c-0.5-0.6-0.7-1.4-0.7-2.2 0-2 1.7-3.8 3.7-3.8 0.8 0 1.5 0.3 2.1 0.7z m-8.8 11.3c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z' })
        )
    );
};

exports.default = IoIosSpeedometerOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-speedometer-outline.js
// module id = 2287
// module chunks = 0